{
  "removeButtonLabel": "Fjern",
  "removeDescription": "Tryk på Slet for at fjerne tag."
}
